import common from '@/common';
import { downloadBlob } from '@/utils/utils';
import { request } from '@umijs/max';
import { message } from 'antd';
import { isEmpty } from 'lodash';
import moment from 'moment';

// 查询订单列表
export async function getOrderListService(data: any) {
  return request(
    common?.projectCode === 'pto'
      ? '/bcare/order/resetQryOrderList'
      : '/bcare/order/qryOrderList',
    {
      method: 'POST',
      data,
    },
  ).then((res) => {
    if (common?.projectCode === 'pto') {
      const orderList = res?.custOrders?.reduce((pre: any[], item: any) => {
        const orderItem = (item?.orderItems || []).map((el: any) => ({
          ...el,
          ...item.custOrder,
        }));
        return [...pre, ...orderItem];
      }, []);
      return {
        list: orderList,
        total: res?.pageResp?.total,
      };
    } else {
      const newData: any[] = [];
      // 如果当前存在号码搜索，则需要返回所有的orderItem包含这个号码的数据
      if (res?.custOrders?.length > 0) {
        if (!isEmpty(data?.accNbr || isEmpty(data?.iccid))) {
          const orderList = res.custOrders.map((v: any) => {
            const orderItem = (v.orderItems || [])?.find(
              (item: any) => item.accNbr === data.accNbr.replace(/^60/, ''),
            );
            return { ...orderItem, custOrder: v.custOrder };
          });
          newData.push(...orderList);
        } else {
          const list = res.custOrders.map((i: any) => {
            let newOrderItem = {};
            // 如果当前orderItems长度大于1,第一个orderItems的servType不是51,则去掉serviceNumber和iccid不展示
            if (i.orderItems.length > 1 && i.orderItems[0]?.servType !== 51) {
              delete i.orderItems[0]?.accNbr;
              delete i.orderItems[0]?.iccid;
              // 如果当前是51 bundle取他对应的服务类型名称,保留号码展示
              const bundleServTypeItem = i.orderItems.find(
                (ele: any) => ele?.servType === 51,
              );
              if (bundleServTypeItem) {
                newOrderItem = {
                  ...bundleServTypeItem,
                  custOrder: i.custOrder,
                  iccid: '',
                };
              } else {
                // 如果不是51则取order的第一条
                newOrderItem = {
                  ...i.orderItems[0],
                  custOrder: i.custOrder,
                };
              }
            } else {
              newOrderItem = { ...i.orderItems[0], custOrder: i.custOrder };
            }

            return newOrderItem;
          });

          newData.push(...list);
        }
      }

      return {
        total: res?.pageResp?.total,
        list: newData,
      };
    }
  });
}

// 获取订单类型
export async function getOrderTypeListService(params: any) {
  return request('/bcare/order/qryOrderType', {
    params,
  }).then((res) => {
    if (res?.orderTypeDtos?.length) {
      const orderTypeDtosData = res?.orderTypeDtos || [];
      return orderTypeDtosData?.map((item: any) => ({
        ...item,
        label: item.orderTypeName,
        value: item.orderType,
      }));
    }
  });
}

// 查询订单状态
export async function getOrderStateListService(params: any) {
  return request('/bcare/order/qryOrderState', {
    params,
  }).then((res) => {
    if (res?.orderStateDtos?.length) {
      return (res?.orderStateDtos || [])?.map((item: any) => ({
        ...item,
        label: item.orderStateName,
        value: item.orderState,
      }));
    }
  });
}

// 查询操作弹框列表
export async function getUserListService(data: any) {
  return request('/bcare/user/front/search', {
    method: 'POST',
    data,
  }).then((res) => {
    return {
      total: res.bcareUsers.length || 0,
      list: res.bcareUsers || [],
    };
  });
}

// 子号码组件查询attachType
export async function getAttachTypeListService(params: any) {
  return request('/bcare/attachType', {
    params,
  }).then((res) => {
    return (res.attachTypeList || [])
      ?.filter((el: any) => el.csrVisible !== 'N')
      .map((item: any) => ({
        label: item.attachTypeName,
        value: item.attachTypeId,
      }));
  });
}

// 查询order详情
export async function getOrderDetailService(params: any) {
  return request(`/bcare/order/qryOrderDetail/${params.custOrderId}`).then(
    (res) => {
      const { custOrderDetail } = res || {};
      // 将orderSubjectDetails对应塞入orderItemDetails内
      const newOrderItemDetails = custOrderDetail?.orderItemDetails?.map(
        (orderDetail: any, index: number) => {
          return {
            ...orderDetail,
            ...custOrderDetail?.orderSubjectDetails?.[index],
            flag: false, // 控制子订单面板折叠
          };
        },
      );

      return {
        custOrder: custOrderDetail?.custOrder || {},
        orderFeeRespDetails:
          custOrderDetail.orderFeeRespDetails[0]?.orderFeeDetailRespDtoList ||
          [],
        orderFee:
          custOrderDetail.orderFeeRespDetails[0]?.orderFeeSubjectRespDto || {},
        custOrderAttachs: custOrderDetail.custOrderAttachs || [],
        orderInfoDetails: custOrderDetail.orderSubjectDetails[0] || [],
        custOrderOtcDetail: custOrderDetail.custOrderOtcDetail,
        orderItemDetails: newOrderItemDetails || [],
        orderSubjectDetails: custOrderDetail.orderSubjectDetails || [],
        deliveryOrderDetail: custOrderDetail?.deliveryOrderDetail || {},
        installType:
          custOrderDetail?.fixInstallOrderDtoList[0]?.installType || '',
        fixInstallOrderDtoList: custOrderDetail?.fixInstallOrderDtoList || [],
      };
    },
  );
}

// 下载文件
export async function downLoadDocService(params: any) {
  return request(`/bcare/file/dms/downloadFile`, {
    responseType: 'blob',
    params,
  }).then((res) => {
    downloadBlob(res, 'text/plain', params.fileName);
  });
}

export async function saveFileService(data: any) {
  return request('/bcare/order/attach', {
    method: 'POST',
    data,
  });
}

// 获取订单详情memoEventType类型
export async function getMemoEventTypeService(params: any) {
  return request('/bcare/order/qryMemoEventType', {
    params,
  }).then((res) => res?.memoEventTypeDtos || []);
}

// 订单施工进度
export async function orderProgressService(params: any) {
  return request('/bcare/tm/order/orderProgress', {
    params,
    method: 'POST',
  });
}

// 查询OSS施工里程碑回填数据
export async function qryOrderStageService(data: any) {
  return request('/bcare/order/qryOrderStage', {
    method: 'POST',
    data,
  });
}

// 改约校验接口
export async function checkRescheduleService(data: any) {
  return request('/bcare/installation/check-reschedule', {
    method: 'POST',
    data,
  });
}

// 改约提交接口
export async function appointmentModifyService(data: any) {
  return request('/bcare/installation/appointment-modify', {
    method: 'POST',
    data,
  });
}

// 查询rush order
export async function queryRushOrderService(data: any) {
  return request('/bcare/installation/rush-orders', {
    method: 'POST',
    data,
  });
}

// 查询时间片bcare/installation/queryslot
export async function querySlotService(data: any) {
  return request('/bcare/installation/queryslot', {
    method: 'POST',
    data,
  });
}

export async function exportOrderListService(data: any) {
  return request(`/bcare/order/export`, {
    method: 'POST',
    data,
    responseType: 'blob',
    skipErrorHandler: true,
    timeout: 300000,
  })
    .then((res) => {
      const typeMapping: Record<string, [string, string]> = {
        excel: [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'xlsx',
        ],
        text: ['text/plain', 'txt'],
      };

      // 检查 docType 是否有效，否则默认用 excel
      const docType = data?.docType || 'excel';
      const [type, suffix] = typeMapping[docType] || []; // 防止解构失败

      if (!type || !suffix) {
        throw new Error('Unsupported docType');
      }

      // 下载文件后缀名称
      const date = new Date();
      const billDownLoadDate = moment(date).format('YYYY/MM/DD HH:mm:ss');

      downloadBlob(res, type, `OrderList_${billDownLoadDate}.${suffix}`);
    })
    .catch((error) => {
      message.error(error?.message);
    });
}
